<template>
  <div class="creditCard">
    <div class="items" v-show="finish == 0">
      <el-form :model="creditCardForm" :rules="rulesForm" ref="creditCardForm" label-width="0" class="creditCardForm">
        <el-form-item prop="amount" v-if="!!!$route.query.tradeSerialNo">
          <p>{{pc_lang.Amount}}</p>
          <el-input v-model="creditCardForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount" size="medium"></el-input>
        </el-form-item>
        <el-form-item prop="cardType">
          <p>信用卡类型</p>
          <el-radio-group v-model="creditCardForm.cardType" size="medium">
              <el-radio :label="1">Visa</el-radio>
              <el-radio :label="0">Master</el-radio>
            </el-radio-group>
          <!-- <el-input v-model="creditCardForm.cardType" prefix-icon="el-icon-bank-card" autocomplete="off" :placeholder="pc_lang.Enter_Credit_Card_No" size="medium"></el-input> -->
        </el-form-item>
        <!-- <el-form-item prop="bank">
          <p>{{pc_lang.Selected_Bank}}</p>
          <el-select v-model="creditCardForm.bank" :placeholder="pc_lang.Select_your_bank" size="medium">
            <el-option label="中国" value="86"></el-option>
            <el-option label="马来西亚" value="60"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="cardNo">
          <p>{{pc_lang.Credit_Card_No}}</p>
          <el-input v-model="creditCardForm.cardNo" prefix-icon="el-icon-bank-card" autocomplete="off" :placeholder="pc_lang.Enter_Credit_Card_No" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="name">
          <p>{{pc_lang.Cardholders_Name}}</p>
          <el-input v-model="creditCardForm.name" prefix-icon="el-icon-user" autocomplete="off" :placeholder="pc_lang.Fill_in_cardholder_name" size="medium"></el-input>
        </el-form-item> -->
        <el-form-item prop="time">
          <p>{{pc_lang.Expire_date}}</p>
          <el-date-picker
            v-model="creditCardForm.time"
            type="month"
            size="medium"
            value-format="timestamp"
            autocomplete="off"
            :placeholder="pc_lang.Select_credit_card_expiration_time">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="cvv2">
          <p>CVV2</p>
          <el-input type="password" v-model="creditCardForm.cvv2" prefix-icon="el-icon-lock" autocomplete="off" :placeholder="pc_lang.Enter_CVV2" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <div v-show="0" class="callbackForm" v-html="callbackForm"></div>
      <div class="submit">
        <p>我已阅读并同意 <span>《信用卡/借记卡条款和条件》</span></p>
        <el-button type="primary" size="medium" class="nextStep" @click="regForm('creditCardForm')">{{pc_lang.Next_step}}</el-button>
      </div>
    </div>

    <div v-show="finish == 1">
      <Finish
      v-if="finish == 1"
      :mainTitle="pc_lang.top_up_successful"
      :descWord="pc_lang.Top_up_successful_access_My_Credit_to_check_the_your_balance"
      :routeA="'/riches'"
      :routeWordA="pc_lang.My_Credit"
      :routeB="'fresh'"
      :routeWordB="pc_lang.Next_top_up"
      :btnBool="true"
      :countBool="true"
      ></Finish>
    </div>

    <AddressPop :addressPopBoolean="addressPopBoolean" @submit="submitAddress"/>
  </div>
</template>

<script>
import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'
import Finish from '@/components/ui/Finish'

import * as API_ADDRESS from '@/api/address'
import AddressPop from '@/components/user/AddressPop'

export default {
  name: 'CreditCard',
  components: {
    Finish,
    AddressPop
  },
  data(){
    return {
      // 提交完成
      finish: 0,
      creditCardForm: {
        amount: '',
        // bank: '',
        cardNo: '',
        // name: '',
        time: '',
        cvv2: '',
      },
      callbackForm: '',
      // 完善地址信息
      addressPopBoolean: false
    }
  },
  computed: {
    rulesForm() {
      // 信用卡号验证
      var validateCVV2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_CVV2));
        } else if (!/^[0-9]{3}$/.test(value)) {
          callback(new Error(this.pc_lang.Enter_the_correct_CVV2));
        } else {
          callback();
        }
      };
      // 金额验证
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_amount));
        } else if (!RegExp.money.test(value)) {
          callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
        } else {
          callback();
        }
      };
      return {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        /*bank: [
          { required: true, message: this.pc_lang.Please_select_the_transfer_bank, trigger: 'change' }
        ],*/
        cardNo: [
          { required: true, message: this.pc_lang.Enter_Credit_Card_No, trigger: 'blur' }
          // { validator: validateCardNo, trigger: 'blur' }
        ],
        cardType: [
          { required: true, message: '请选择卡类型', trigger: 'blur' }
          // { validator: validateCardNo, trigger: 'blur' }
        ],
        /*name: [
          { required: true, message: this.pc_lang.Fill_in_cardholder_name, trigger: 'blur' }
        ],*/
        time: [
          { required: true, message: this.pc_lang.Select_credit_card_expiration_time, trigger: 'blur' }
        ],
        cvv2: [
          // { required: true, message: '请输入CVV2', trigger: 'blur' }
          { validator: validateCVV2, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getAddressList()
  },
  async mounted() {

  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let hasAddress = await this.getAddressList()
          if ( hasAddress ) {
            this.getPayItem().then(()=>{
              document.querySelector('.callbackForm form').submit()
            })
          }
        }else{
          return false
        }
      })
    },
    /* 获取支付表单 */
    getPayItem() {
      return new Promise((resolve, reject)=> {
        let params = {
          paymentPluginId: 'creditPayPlugin',
          payMode: 'normal',
          clientType: 'PC',
          sn: this.$route.query.tradeSerialNo || new Date().getTime(),
          tradeType: this.$route.query.tradeSerialNo == undefined ? 'recharge' : 'order',
          ...this.creditCardForm,
          amount: this.$route.query.tradeSerialNo == undefined ? this.creditCardForm.amount : ''
        }
        API_PAY.getPayQrCode(params.tradeType, params.sn, params).then(res=> {
          this.callbackForm = res.data.gateway_url
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 获取地址列表，如果没有，允许提交 */
    getAddressList() {
      return new Promise((resolve, reject)=> {
        API_ADDRESS.getAddressList().then(res=> {
        const { data } = res
        if ( !!!data.length ) {
          resolve(false)
          this.$message_box.alert(`${ this.pc_lang['CreditNeedAddress'] }`, `Tips`, {
            confirmButtonText: `${ this.pc_lang['Confirm2'] }`,
            callback: action => {
              this.addressPopBoolean = true
            }
          })
        } else {
          resolve(true)
        }
      })
      })
    },
    submitAddress() {
      this.$message({
        type: 'success',
        message: `信息已更新！`
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.creditCard{
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .submit{
    p{
      padding: 10px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
}
</style>